'use client';

import type { HTMLAttributes, ReactNode } from 'react';
import { useId } from 'react';
import { BypassTargetButton } from './BypassTargetButton';
import { BypassLink } from './BypassLink';

export type BypassBlockProps = Pick<HTMLAttributes<HTMLDivElement>, 'className'> & {
  /**
   * The content that should be skipped.
   */
  children: ReactNode;
  /**
   * The text that will be displayed on the button, e.g. "Skip header".
   */
  buttonText: string;
  /**
   * Whether or not you want to skip the scrollTo function.
   */
  skipScrollIntoView?: boolean;
};

/**
 * A component that allows users to skip a block of content.
 */
const BypassBlock = ({
  // ToDO : buttonText prop name has to be changed to linkText
  children,
  buttonText,
  skipScrollIntoView,
  className,
  ...props
}: BypassBlockProps) => {
  const anchorId = useId();

  return (
    <div {...props} className={`relative ${className ?? ''}`}>
      <BypassLink
        linkText={buttonText}
        anchorId={anchorId}
        skipScrollIntoView={skipScrollIntoView}
      />
      {children}
      <BypassTargetButton id={anchorId} />
    </div>
  );
};

export { BypassBlock };
